export const INSTANCE_NAME_STORAGE_KEY = 'instanceName';
export const BACK_TO_STORAGE_KEY = 'backTo';
